import React, { useRef, useState } from "react";

import { MAX_UPLOAD_FILE_SIZE_BYTES } from "constants/constants";
import { Icon } from "widgets";

import {
  UPLOAD_COPY,
  UPLOAD_FILE_ACCEPT,
  UPLOAD_ICONS,
} from "../../constants/uploadsContent";
import styles from "./FileUpload.module.scss";

const FileUpload = ({
  selectedFile,
  onFileChange,
  onFileError,
  disabled = false,
}) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const validateAndSelectFile = (file) => {
    if (!file || !onFileChange) {
      return;
    }

    if (file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
      onFileError?.(UPLOAD_COPY.FILE_SIZE_ERROR);
      return;
    }

    onFileChange(file);
  };

  const handleInputChange = (event) => {
    validateAndSelectFile(event.target.files?.[0]);
    event.target.value = "";
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    if (!disabled) {
      setIsDragging(true);
    }
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);

    if (!disabled) {
      validateAndSelectFile(event.dataTransfer.files?.[0]);
    }
  };

  const openFilePicker = () => {
    if (!disabled) {
      fileInputRef.current?.click();
    }
  };

  const dropZoneClassName = [
    styles.dropZone,
    isDragging ? styles.dropZoneActive : "",
    disabled ? styles.dropZoneDisabled : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={styles.mainContainer}>
      <div
        className={dropZoneClassName}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={openFilePicker}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            openFilePicker();
          }
        }}
        role="button"
        tabIndex={disabled ? -1 : 0}
        aria-disabled={disabled}
      >
        <Icon name={UPLOAD_ICONS.CLOUD_UPLOAD} className={styles.uploadIcon} />

        {selectedFile ? (
          <div className={styles.selectedFile}>
            <Icon
              name={UPLOAD_ICONS.INSERT_DRIVE_FILE}
              className={styles.fileIcon}
            />
            <span className={styles.fileName}>{selectedFile.name}</span>
          </div>
        ) : (
          <p className={styles.dropTitle}>{UPLOAD_COPY.DROP_TITLE}</p>
        )}

        <button
          type="button"
          className={styles.browseButton}
          onClick={(event) => {
            event.stopPropagation();
            openFilePicker();
          }}
          disabled={disabled}
        >
          {UPLOAD_COPY.BROWSE_BUTTON}
        </button>

        <p className={styles.hint}>{UPLOAD_COPY.FILE_HINT}</p>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept={UPLOAD_FILE_ACCEPT}
        onChange={handleInputChange}
        className={styles.hiddenInput}
        disabled={disabled}
      />
    </div>
  );
};

export default FileUpload;
